export default __webpack_public_path__ + "static/get_involved-6d565c909d0e1257f880d31b1e26b908.png";